import React from 'react'
import PropTypes from 'prop-types'
import formatMessage from 'format-message'
import { IosSwitch } from '@CommonComponents'
import { Tooltip, OverlayTrigger } from 'react-bootstrap'

class ReaderToolbarHighlightSwitch extends React.Component {
  static propTypes = {
    isModal: PropTypes.bool.isRequired,
  }

  state = {
    highlightSwitch:
      $.jStorage.get('highlighter-on') != null
        ? $.jStorage.get('highlighter-on')
        : false,
  }

  handleHighlightSwitch = () => {
    let highlightSwitch = !this.state.highlightSwitch
    this.setState({ highlightSwitch: highlightSwitch }, () => {
      if (this.state.highlightSwitch) {
        window.setHighlightMode(true)
        window.resetHighlights(false)
      } else {
        window.setHighlightMode(false)
        window.resetHighlights(false)
      }
    })
  }

  render() {
    const highlightTooltip = (
      <Tooltip id="highlight_tooltip">
        {formatMessage('Toggle the highlighting tool on and off')}
      </Tooltip>
    )

    return (
      <div>
        {!this.props.isModal ? (
          <div className="booktools_item">
            <OverlayTrigger placement="top" overlay={highlightTooltip}>
              <div className="booktools_item_title">
                <label className="d-flex">
                  <span className="align-self-center mr-4">
                    {formatMessage('Highlighting')}
                  </span>
                  <IosSwitch
                    onChange={this.handleHighlightSwitch}
                    checked={this.state.highlightSwitch}
                    scale="0.7"
                  />
                </label>
              </div>
            </OverlayTrigger>
            <div className="clearfix" />
          </div>
        ) : (
          <div />
        )}
      </div>
    )
  }
}

export default ReaderToolbarHighlightSwitch
